/**
 * Created by anatolij on 29.09.2026
 */

const RoyalLeagueWindow = Prefab.createWindow(
    "royal_league_window",
    "royal_league_window_prefab_json"
);
